/**
 * A ENCENAÇÃO do Progresso no cartão flutuante (§5.1): um atalho determinístico
 * (`/panorama`) termina num piscar e todas as etapas chegam concluídas juntas —
 * ninguém vê o andamento. Aqui só o que a TELA mostra é ritmado; o trabalho, o
 * texto, as entregas e o aside seguem no tempo deles.
 *
 * Puras: quantas etapas já podem aparecer como encerradas (`alvoDaEncenacao`),
 * o intervalo entre uma e outra (`intervaloDaEncenacao`, teto total) e a lista
 * como ela é mostrada com `revelados` etapas encerradas (`passosEncenados`).
 */
import { ESTADO_DO_ITEM_DO_PLANO, STATUS_DO_PASSO } from './progresso-do-turno'

const TERMINAIS = new Set([STATUS_DO_PASSO.CONCLUIDA, STATUS_DO_PASSO.FALHOU])

/** Quantas etapas o REAL já encerrou, do começo (o prefixo terminal). */
export function alvoDaEncenacao(passos) {
  const lista = passos || []
  let alvo = 0
  while (alvo < lista.length && TERMINAIS.has(lista[alvo].status)) alvo += 1
  return alvo
}

/**
 * O intervalo entre duas etapas: `dwell` normal, mas o turno inteiro não passa
 * do teto — com muitas etapas ele encolhe (nunca abaixo do piso).
 */
export function intervaloDaEncenacao({ total, dwell, teto, piso }) {
  const quantidade = Number(total) || 0
  if (quantidade <= 0) return dwell
  return Math.max(piso, Math.min(dwell, Math.round(teto / quantidade)))
}

/**
 * A lista como a tela mostra: as `revelados` primeiras com o status REAL, a
 * seguinte em andamento (é a que está "acontecendo") e o resto pendente.
 * `revelados >= total` devolve a lista real — o estado final sempre vence.
 */
export function passosEncenados(passos, revelados) {
  const lista = passos || []
  if (revelados >= lista.length) return lista
  return lista.map(function (passo, i) {
    if (i < revelados) return passo
    const status = i === revelados ? STATUS_DO_PASSO.EM_ANDAMENTO : STATUS_DO_PASSO.PENDENTE
    if (passo.status === status) return passo
    return { ...passo, status }
  })
}

/** A mesma ASSINATURA para os dois consumidores: os rótulos das etapas, na ordem. */
export function assinaturaDePlano(rotulos) {
  return (rotulos || []).join('\u0001')
}

/**
 * A mesma encenação no vocabulário do CONTRATO (`itens` do evento `plano`, que
 * a bolha desenha): `concluido`/`em_andamento`/`pendente`.
 */
export function itensEncenados(itens, revelados) {
  const lista = itens || []
  if (revelados >= lista.length) return lista
  return lista.map(function (item, i) {
    const estado = i === revelados ? ESTADO_DO_ITEM_DO_PLANO.EM_ANDAMENTO : ESTADO_DO_ITEM_DO_PLANO.PENDENTE
    if (i < revelados) return item
    if (item.estado === estado && !item.erro) return item
    const encenado = { ...item, estado }
    delete encenado.erro
    return encenado
  })
}
